import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import "./App.css";
import { store } from "../globalState/Store";
import AuthenticationProvider from "./AuthenticationProvider";
import MessageProvider from "./MessageProvider";
import AppRoutes from "../Routes/AppRoutes";
import AppPhoneChecker from "./AppPhoneChecker";
import "react-phone-input-2/lib/style.css";

function App() {
    return (
        <Provider store={store}>
            <AuthenticationProvider>
                <AppPhoneChecker>
                    <MessageProvider>
                        <BrowserRouter
                            basename={process.env.REACT_APP_BASE_NAME || "/"}
                        >
                            <AppRoutes />
                        </BrowserRouter>
                    </MessageProvider>
                </AppPhoneChecker>
            </AuthenticationProvider>
        </Provider>
    );
}

export default App;
